import React, { useEffect, useRef, useState, type FC, type ReactNode } from 'react'

const DropdownMenu: FC<{ trigger: ReactNode; items: { label: string; icon?: ReactNode; onClick: () => void; danger?: boolean }[] }> = ({ trigger, items }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} className="relative">
      <div onClick={() => setOpen(v => !v)}>{trigger}</div>
      {open && (
        <div className="absolute right-0 top-full mt-1.5 bg-white border border-gray-100 rounded-2xl shadow-xl min-w-[160px] overflow-hidden z-50 py-1">
          {items.map((item, i) => (
            <button key={i} onClick={() => { item.onClick(); setOpen(false); }}
              className={`flex items-center gap-2.5 w-full px-4 py-2.5 text-sm font-medium border-none bg-transparent cursor-pointer transition-colors text-left
                ${item.danger ? "text-red-500 hover:bg-red-50" : "text-stone-700 hover:bg-gray-50"}`}>
              {item.icon}<span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu